import * as React from 'react';

import {getBackgroundUrl} from '@common/typescript/Utils';

import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';
import {getImagePath} from '@app/objects/Image';

const AreaPreview = (props) => {
	const {area, currentAreaUrl} = props;
	const avatarHeight = 360;
	const avatarWidth = 360;
	return (
		<>
			<div
				className="area-page__avatar"
				style={{backgroundImage: getBackgroundUrl(getImagePath(area.avatar, avatarHeight, avatarWidth))}}/>
			<header className="area-page__header header-area">
					<h4 className="header-area__title">{area.name}</h4>
				<p className="header-area__caption">Contact information</p>
				<p className="header-area__phones">
					<a className="header-area__phone" href={`tel:${area.phoneNumber}`}>
						<span>{area.phoneNumber}</span>
					</a>
					<a className="header-area__phone" href={`tel:${area.secondPhoneNumber}`}>
						<span>{area.secondPhoneNumber}</span>
					</a>
				</p>
				<a className="header-area__email" href={`mailto: ${area.email}`}>{area.email}</a>
				<LinkMore linkMoreCaption="Schedule Appointment" linkMoreLink={`${currentAreaUrl}/request-info`} />
			</header>
		</>
	);
};

export default AreaPreview;